(function() {
  define('tlhServicesImage',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesImage', []).factory('TlhImageService', [
      '$q', 'TlhFileService', function($q, TlhFileService) {
        var factory, getResizedImage;
        factory = {};
        factory.isImageType = function(mimeType) {
          return mimeType && mimeType.match(/image.*/);
        };
        factory.isImageFile = function(file) {
          return file && factory.isImageType(file.type);
        };
        factory.resizeImageFiles = function(files, maxWidth) {
          var images;
          images = [];
          return files.reduce(function(sourcesPromise, file) {
            return sourcesPromise.then(function(images) {
              return factory.resizeImageFile(file, maxWidth).then(function(resizedImage) {
                console.log('image resized (' + resizedImage.filename + ')');
                images.push(resizedImage);
                return images;
              });
            });
          }, $q.when(images));
        };
        factory.resizeInput = function(input, maxWidth) {
          return $q(function(resolve, reject) {
            if (input.files && input.files[0]) {
              return resolve(factory.resizeImageFile(input.files[0], maxWidth));
            } else {
              return reject('No file to resize.');
            }
          });
        };
        factory.resizeImageFile = function(file, maxWidth) {
          return $q(function(resolve, reject) {
            if (factory.isImageFile(file)) {
              return getResizedImage(file, maxWidth).then(function(resizedDataUrl) {
                return resolve({
                  mimeType: file.type,
                  filename: file.name,
                  dataUrl: resizedDataUrl
                });
              });
            } else {
              return reject('Wrong type of file. Only images are accepted.');
            }
          });
        };
        getResizedImage = function(file, maxWidth) {
          var URL;
          URL = window.URL || window.webkitURL;
          if (maxWidth == null) {
            maxWidth = 0;
          }
          return $q(function(resolve) {
            var canvas, ctx, image;
            image = new Image();
            canvas = document.createElement('canvas');
            ctx = canvas.getContext('2d');
            image.onload = function() {
              var url;
              URL.revokeObjectURL(image.src);
              if (image.width > maxWidth) {
                if (image.width * 0.5 > maxWidth) {
                  canvas.width = image.width * 0.5;
                  canvas.height = image.height * 0.5;
                } else {
                  canvas.width = maxWidth;
                  canvas.height = Math.round(maxWidth / image.width * image.height);
                }
                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                return canvas.toBlob(function(blob) {
                  return image.src = URL.createObjectURL(blob);
                }, file.type);
              } else {
                canvas.width = image.width;
                canvas.height = image.height;
                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                image = null;
                url = canvas.toDataURL(file.type);
                canvas = null;
                ctx = null;
                resolve(url);
                return url = null;
              }
            };
            return image.src = URL.createObjectURL(file);
          });
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=image.js.map
;
